import "./App.css";

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import TopBar from "./components/topBar/TopBar";
import BottomBar from "./components/bottomBar/BottomBar";
import LandingPage from "./components/landingPage/LandingPage";
import PrivacyPolicy from "./components/privacypolicy/PrivacyPolicy";
import Terms from "./components/terms/Terms";

function App() {
  return (
    <div className="App">
      <TopBar />
      <Router>
        <Routes>
          <Route
            path="/"
            element={
              <div>
                <LandingPage />
                <BottomBar />
              </div>
            }
          />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
